"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ListSignatureRequestTemplatesQuery () {
        return ListSignatureRequestTemplatesQuery;
    },
    get SignatureRequestTemplateSortBySchema () {
        return SignatureRequestTemplateSortBySchema;
    }
});
const _zod = require("zod");
const SignatureRequestTemplateSortBySchema = _zod.z.enum([
    "name",
    "last_update",
    "actorCount"
]);
const ListSignatureRequestTemplatesQuery = _zod.z.object({
    sortBy: SignatureRequestTemplateSortBySchema.default("name"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc"),
    limit: _zod.z.coerce.number().int().min(1).max(100).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
